<template>
	<!-- 隐患审核 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getPageList">查询</el-button>
				</el-form-item>
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="pagelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="checkNumber" label="检查编号" align="center" min-width="180">
			</el-table-column>
			<el-table-column prop="coName" label="企业名称" min-width="200" align="center">
			</el-table-column>
			<el-table-column prop="cityName" label="所属城市" min-width="100" align="center">
			</el-table-column>
      		<el-table-column prop="checkTime" label="检查时间" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="yhStatusName" label="隐患状态" align="center"  min-width="100">
			</el-table-column>
      		
			<el-table-column  label="操作" align="center" width="300">
				<template slot-scope="scope">
					<el-button  type="primary"  size="small" @click="yhDetail(scope.$index, scope.row)">隐患详情</el-button>
					<el-button  type="danger" size="small" @click="handleZG(scope.$index, scope.row)">下发整改</el-button>
					<el-button  type="success" size="small" @click="handleyhStatus(scope.$index, scope.row)">查验合格</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--设置整改日期-->
		<el-dialog :title="editFormTitle" v-model="editFormVisible" :close-on-click-modal="false">
      		<el-form :model="editForm" label-width="200px" :rules="editFormRules" ref="editForm">	
				<el-form-item label="上传责令整改通知书" >
					<div>
						<input  ref="upLoadRef" type="file" @change.stop="handleFileUpload">
						<button  v-show="uploadstart" @click.stop.prevent="uploadGjFile">上传</button>
					</div>
				</el-form-item>
				<el-form-item label="整改截止日期" prop="correctDeadTime">
					<el-date-picker v-model="editForm.selCorrectDeadTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>
				请提前准备好“责令整改通知书”扫描件，上传文件成功后，再设置整改截止日期。
      		</el-form>
      
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">关闭</el-button>
				<el-button type="primary" @click.native="updateCDTime" :loading="editLoading">保存</el-button>
			</div>
		</el-dialog>

		<!--详情界面-->
		<el-dialog  title="隐患详情" v-model="detailFormVisible" :close-on-click-modal="false">

			<div class="grid-content bg-purple">
				<label>企业名称:  {{detailForm.coName}}</label>
			</div>

			<div class="grid-content bg-purple-light">
				<label>检查编号:  {{detailForm.checkNumber}} </label>
			</div>

			<div class="grid-content">
				<label>检查时间:  {{detailForm.checkTime}} </label>
			</div>

			<div v-for="(item, index) in feedata" :key="index" style="margin-top: 20px;">
				<div class="grid-content bg-purple">
					<label>【{{item.checkType}}】{{item.checkContent}}</label>
				</div>
				<div class="grid-content bg-purple-light">
					<label>检查结果:  {{item.checkResult=='1'?'合格':'不合格'}} </label>
				</div>
				<div class="grid-content">
					<label>检查备注:  {{item.checkDesc}} </label>
				</div>
				<div class="image-container">
					<div v-for="picurl in item.picList" :key="picurl" class="image-item">
					<img :src="picbaseurl+picurl" alt="Image" @click.self="showBigImage(picbaseurl+picurl)">
					</div>
				</div>
				<hr>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="detailFormVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<!--4-2显示放大图片的组件-->
		<BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}"></BigImg>

	</section>
</template>

<script>
	// 4-1 
	import BigImg from "../../components/big-img"
	import axios from 'axios';
	import { gjCheckList,updateYhOK,updateCorrectDeadTime,gjCheckDetailList} from '../../api/api';

	export default {
		components:{
			BigImg:BigImg
    	},
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到

				filters: {
					companyName: ''
				},
				pagelist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//隐患详情
				detailFormVisible: false,
				feedata: [],
				detailForm: {
					coName:"",
					checkNumber:"",
					checkTime: "",
				},

				//编辑
				editFormTitle:'',  //编辑的时候，显示企业名称
				editFormVisible: false, 
				editLoading: false,
				editFormRules: {
				},
				
				editForm: {
					checkNumber:"",
					correctNoticeURL:"",
					correctDeadTime:"",     
					selCorrectDeadTime:null,
				},

				//上传通知书
				uploadstart:true,
				imageFile: null,

				picbaseurl:"https://aqjg.ycsyzglj.com/",

				// 4-5
				photoVisible:false,
				bigImgUrl:""
				
			}
		},
		methods: {
			handleFileUpload(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='pdf'){
					this.imageFile = event.target.files[0];
				}else{
					this.imageFile = null;
					this.$message.error("请选择pdf格式的文件");
				}
			},
			uploadGjFile() {
				if(this.imageFile!=null){
					let formData = new FormData();
					formData.append('file', this.imageFile);
					formData.append('filetype', "Yhpczl");
					formData.append('secondarydir', "yhpczl_gj_"+this.objectId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.editForm.correctNoticeURL = response.data.data.url;
							this.uploadstart=false
							this.$message.success("文件上传成功，请填写其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
			//4-4点击图片函数，点击后，把photoVisible设置成true
			showBigImage(e) {
				if (e != "") {
					this.photoVisible = true;
					this.bigImgUrl = e;
				}
			},
			handleCurrentChange(val) {				
				this.page = val;
				this.getPageList();
			},
			//获取分页列表
			getPageList() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					coName: this.filters.companyName,
					checkType:"view",
				};

				this.listLoading = true;

				gjCheckList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.pagelist = res.data.data.list;
					}
					
					this.listLoading = false;
				});
			},
			handleZG: function (index, row) {
				this.editFormVisible = true;
				this.editFormTitle = row.coName
				
				this.editForm={
					checkNumber: row.checkNumber,
					correctDeadTime:"",     
					selCorrectDeadTime:null,
				}
				this.imageFile = null;
				this.uploadstart=true
				if (this.$refs.upLoadRef) {
					this.$refs.upLoadRef.value = '' // 置空input文件
				}
			},
			updateCDTime: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交整改期限吗？', '提示', {}).then(() => {
						this.editLoading = true;

						if(this.editForm.selCorrectDeadTime!=null){
							this.editForm.correctDeadTime = this.editForm.selCorrectDeadTime.toLocaleString();
						}
    
						updateCorrectDeadTime(this.editForm).then((res) => {
								this.editLoading = false;
								this.editFormVisible = false;
								if(res.data.code==0){
									this.$message.success(res.data.message);
									this.getPageList();
								}
								else{
									this.$message.error(res.data.message);
								}
							});
						});
					}
				});
			},	
			handleyhStatus: function (index, row) {
					this.$confirm('确认 '+row.coName+' 隐患查验合格吗？', '提示', {}).then(() => {
					let deletecompanyparam={
						checkNumber:row.checkNumber,
						yhStatus:"CYHG",
					}

					updateYhOK(deletecompanyparam).then((res) => {
						if(res.data.code==0){
						this.$message.success(res.data.message);
						this.getPageList();
						}
						else{
						this.$message.error(res.data.message);
						}
					});
				});	
			},	
			yhDetail: function (index, row) {
				this.detailForm.coName=row.coName
				this.detailForm.checkNumber=row.checkNumber
				this.detailForm.checkTime=row.checkTime
				let para = {
					checkNumber: row.checkNumber
				};

				gjCheckDetailList(para).then((res) => {
					this.detailFormVisible=true
					if(res.data.code==0){
						this.feedata=res.data.data
					}
					
				});
			},	
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.getPageList();
		}
	}

</script>

<style scoped>

	
</style>


// WEBPACK FOOTER //
// checkView.vue?689d7b0a